import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import type { PerformanceMarker, WithPerformanceMarkerProps } from './types';

export const PerformanceMarkerContext = React.createContext<PerformanceMarker | null>(null);

export const withPerformanceMarker = <Props extends WithPerformanceMarkerProps>(
  Component: React.ComponentType<Props>
) => hoistNonReactStatics(class extends React.PureComponent<Omit<Props, keyof WithPerformanceMarkerProps>> {
    static displayName = `withPerformanceMarker(${getDisplayName(Component)})`;

    render() {
      return (
        <PerformanceMarkerContext.Consumer>
          {context => <Component perfMarker={context} {...this.props as Props} />}
        </PerformanceMarkerContext.Consumer>
      );
    }
  }, Component);
